function fileHasCsvExtension(file) {
    return file.name.toLowerCase().endsWith('.csv');
}

async function fileAppearsToContainCsvContent(file) {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = (event) => {
            resolve(fileContentsAppearsToContainCsvData(event.target.result));
        };
        reader.readAsText(file);
    });
}

function fileContentsAppearsToContainCsvData(fileContent) {
    if (fileContent == null)
        return false;

    const lines = fileContent.split(/\r\n|\n/);
    if(lines.length == 0)
        return false;

    // This is a simple test to hopefully eliminate files that are not actually CSV files.
    // We assume that missing, and/or re-ordered columns, etc. will be detected and dealt with by the C#.
    const header = lines[0];
    return header.toLowerCase().includes(',');
}

export { fileHasCsvExtension, fileAppearsToContainCsvContent, fileContentsAppearsToContainCsvData }
